import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';

import { CanDeactivateGuardService } from '../../core/can-deactivate-guard.service';
import { AvisoPesquisaComponent } from './aviso-pesquisa.component';
import { AvisoCadastroComponent } from './aviso-cadastro.component';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';


const routes: Routes = [
  {
    path: 'avisos/pesquisa',
    component: AvisoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	agentes: AgenteFinanceiroResolver,
    },
    data: { refreshAgentes: true }
    // data: { canReuse: false } // inviabilizado pelas melhorias da SOL00129375
  }
  ,{
    path: 'avisos/:id',
    component: AvisoCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    resolve: {
    	agentes: AgenteFinanceiroResolver,
    },
    data: { canReuse: false }
  },

  {
    path: 'avisos',
    component: AvisoCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    resolve: {
    	agentes: AgenteFinanceiroResolver,
    },
    data: { canReuse: false }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AvisoRoutingModule { }
